export const convertStatusToLabel = (status: string) => {
  switch (status) {
    case "AWAITING_ANALYSIS":
      return "Aguardando Análise";
    case "IN_PROGRESS":
      return "Em Andamento";
    case "RESOLVED":
      return "Concluída";
    case "FILED":
      return "Arquivada";
    case "RETURNED":
      return "Devolvida";
    case "REJECTED":
      return "Rejeitada";
    case "CANCELLED":
      return "Cancelada";
    case "REOPENED":
      return "Reaberta";
    case "AWAITING_REANALYSIS":
      return "Aguardando Reanálise";
    default:
      return status;
  }
};
